package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val ErrorColorVariant = ColorVariant(
    n25 = Color(0xFFFFFBFA),
    n50 = Color(0xFFFEF3F2),
    n100 = Color(0xFFFEE4E2),
    n200 = Color(0xFFFECDCA),
    n300 = Color(0xFFFDA29B),
    n400 = Color(0xFFF97066),
    n500 = Color(0xFFF04438),
    n600 = Color(0xFFD92D20),
    n700 = Color(0xFFB42318),
    n800 = Color(0xFF912018),
    n900 = Color(0xFF7A271A)
)
